import React from 'react'
import Svg from '../Svg'

const Icon: React.FC<any> = ({ fill, isMobile, isSearch, ...props }) => {
  return isMobile ? (
    isSearch?.keyword?.length > 0 ? (
      <Svg width="20" height="20" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12.5" cy="12.5" r="12.5" fill="#6D6D6D" />
        <rect
          x="7.13837"
          y="4.88965"
          width="18.1891"
          height="3.18624"
          rx="1.59312"
          transform="rotate(45 7.13837 4.88965)"
          fill="white"
        />
        <rect
          x="4.88531"
          y="17.8608"
          width="18.1891"
          height="3.18624"
          rx="1.59312"
          transform="rotate(-45 4.88531 17.8608)"
          fill="white"
        />
      </Svg>
    ) : (
      <Svg/>
    )
  ) : (
    <Svg viewBox="0 0 22 23" xmlns="http://www.w3.org/2000/svg" fill="none" {...props}>
      <circle cx="8.79774" cy="8.93494" r="6.6742" stroke={fill} strokeWidth="3" />
      <path d="M13.7932 14.3848L20.605 20.7425" stroke={fill} strokeWidth="4" />
    </Svg>
  )
}

export default Icon
